var _path, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgRoktreact = function SvgRoktreact(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 80 40"
  }, props), /*#__PURE__*/React.createElement("mask", {
    id: "rokt_react_svg__a",
    width: 56,
    height: 16,
    x: 12,
    y: 12,
    maskUnits: "userSpaceOnUse",
    style: {
      maskType: "luminance"
    }
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M68 12H12v15.68h56V12Z"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "#686868",
    mask: "url(#rokt_react_svg__a)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M20.35 17.03c0-1.31-.65-2-2.2-2h-2v4.02h2c1.55 0 2.2-.67 2.2-2.02Zm4.35.04c0 1.61-.8 2.73-2.31 3.6l3.33 6.65h-4.67L18.4 21.8h-2.24v5.52H12V12.28h6.8c4.06 0 5.9 1.96 5.9 4.8Zm30.88-4.75-1.62 3.18h5.3v11.85h4.18V15.5H68v-3.18H55.58Zm-3.64-.02h2.28l-8.94 7.32v-2.54l6.66-4.78Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M51.92 12.3h2.37l-3.44 6.72-3.76 1.7 4.83-8.42Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m47.08 20.72 3.76-1.7 4.1 8.29h-4.69l-3.17-6.59Zm-1.72-8.41H41.2v15.02h4.16V12.3Z"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    d: "M32.84 12c-2.15 0-3.88.7-5.17 2.1-1.3 1.4-1.95 3.3-1.95 5.72v.04c0 2.43.65 4.34 1.95 5.74a6.73 6.73 0 0 0 5.17 2.08c2.14 0 3.87-.69 5.15-2.08 1.3-1.4 1.94-3.31 1.94-5.74v-.04c0-2.43-.65-4.32-1.94-5.71C36.7 12.7 34.98 12 32.84 12Zm-.02 3.05c-.88 0-1.58.45-2.11 1.32-.53.87-.8 2.05-.8 3.57v.03c0 1.51.27 2.71.8 3.58.53.87 1.23 1.3 2.1 1.3.88 0 1.59-.43 2.1-1.3.53-.87.8-2.07.8-3.58v-.03c0-1.52-.26-2.7-.8-3.57-.52-.87-1.22-1.31-2.1-1.31Z",
    clipRule: "evenodd"
  }))));
};
export default SvgRoktreact;